/**
 * Known mappings for staff email addresses to their official First Name + Last Name.
 */
export const KNOWN_USER_NAMES = {
  'technician@abacustelecomm.co.za': 'Dominic De Groot',
  'dominic@abacustelecomm.co.za': 'Dominic Sardinha',
  'dominicdegroot0804@gmail.com': 'Dominic De Groot',
  'blessing@abacustelecomm.co.za': 'Blessing Chikwanha',
  'chikwanhablessing24@gmail.com': 'Blessing Chikwanha',
  'herman@abacustelecomm.co.za': 'Herman Bester',
  'tashreeq@abacustelecomm.co.za': 'Tashreeq Wagner',
  'rushdiya@abacustelecomm.co.za': 'Rushdiya Moses',
  'gabbey@abacustelecomm.co.za': 'Gabbey Hayward',
  'angelo@abacustelecomm.co.za': "Angelo D'Ambrosio",
};

/**
 * Known first-name-only mappings to full names for historical comments
 */
export const KNOWN_FIRST_NAMES = {
  'dominic': 'Dominic De Groot',
  'blessing': 'Blessing Chikwanha',
  'herman': 'Herman Bester',
  'tashreeq': 'Tashreeq Wagner',
  'rushdiya': 'Rushdiya Moses',
  'gabbey': 'Gabbey Hayward',
  'angelo': "Angelo D'Ambrosio",
  'technician': 'Dominic De Groot',
};

/**
 * Resolves a full First Name + Last Name for any user object, displayName, or email.
 * E.g., returns "Dominic De Groot" rather than "dominic" or "technician".
 */
export function resolveUserFullName(userOrName, emailFallback) {
  // If user object passed (e.g. Firebase Auth user)
  if (userOrName && typeof userOrName === 'object') {
    if (userOrName.displayName && typeof userOrName.displayName === 'string' && userOrName.displayName.trim()) {
      return userOrName.displayName.trim();
    }
    const email = (userOrName.email || '').toLowerCase().trim();
    if (KNOWN_USER_NAMES[email]) return KNOWN_USER_NAMES[email];
    if (userOrName.name && typeof userOrName.name === 'string' && userOrName.name.trim()) {
      return userOrName.name.trim();
    }
  }

  // If a string was passed (could be a full name, email, or single name)
  if (typeof userOrName === 'string' && userOrName.trim()) {
    const trimmed = userOrName.trim();
    // If it's an email
    if (trimmed.includes('@')) {
      const lower = trimmed.toLowerCase();
      if (KNOWN_USER_NAMES[lower]) return KNOWN_USER_NAMES[lower];
    } else if (trimmed.includes(' ')) {
      // Already has first and last name!
      return trimmed;
    } else {
      // Single word, check if it's a known first name
      const lowerSingle = trimmed.toLowerCase();
      if (KNOWN_FIRST_NAMES[lowerSingle]) {
        return KNOWN_FIRST_NAMES[lowerSingle];
      }
    }
  }

  // Check email fallback
  if (emailFallback && typeof emailFallback === 'string') {
    const lowerEmail = emailFallback.toLowerCase().trim();
    if (KNOWN_USER_NAMES[lowerEmail]) return KNOWN_USER_NAMES[lowerEmail];

    // If email is like "first.last@domain.com"
    const prefix = lowerEmail.split('@')[0];
    if (KNOWN_FIRST_NAMES[prefix]) {
      return KNOWN_FIRST_NAMES[prefix];
    }
    if (prefix.includes('.') || prefix.includes('_') || prefix.includes('-')) {
      return prefix
        .split(/[._-]+/)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ');
    }
  }

  if (typeof userOrName === 'string' && userOrName.trim() && !userOrName.includes('@')) {
    return userOrName.trim();
  }

  return 'Dominic De Groot';
}
